import ApiClient from '@/api/ApiClient';

const ROUTE = 'tempworker/tempworkerinformation';
const client = new ApiClient(ROUTE);

class TempWorkerInformationApiTempWorker {

	static updateIntroduction (updateIntroductionTempWorkerInformationModel: IUpdateIntroductionTempWorkerInformationModel) {
		return client.put<void>(`${updateIntroductionTempWorkerInformationModel.id}/introduction`, updateIntroductionTempWorkerInformationModel);
	}

	static updateHasPersonalVehicle (updateHasPersonalVehicleTempWorkerInformationModel: IUpdateHasPersonalVehicleTempWorkerInformationModel) {
		return client.put<void>(`
    ${updateHasPersonalVehicleTempWorkerInformationModel.id}/haspersonalvehicle`, updateHasPersonalVehicleTempWorkerInformationModel,
		);
	}

	static updateMobility (updateMobilityTempWorkerInformationModel: IUpdateMobilityTempWorkerInformationModel) {
		return client.put<void>(`${updateMobilityTempWorkerInformationModel.id}/mobility`, updateMobilityTempWorkerInformationModel);
	}

}

export default TempWorkerInformationApiTempWorker;
